<template>
	<div class="">
		<form class="bg-white px-8 pt-6 pb-8 mb-4" @reload="reload">
			<fetch-json url="profileswithusersbyregion" method="get" :params="{profile_id: [3,4,5,6], region: job.details.region}" :key="job.details.region">
			<div class="flex" slot-scope="{ data: profiles, loading }">
				<div class="w-1/2">
					<div class="mb-4 p-1">
						<label class="block text-gray-700 text-sm mb-2" for="username">
							Job name
						</label>
						<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="job_name" v-model="job.details.name" type="text" placeholder="Job name">
					</div>
					<div class="mb-4 p-1">
						<label class="block text-gray-700 text-sm mb-2" for="province">
							Region
						</label>
						<div class="w-full inline-block relative">
							<select v-model="job.details.region" name="region" class="block appearance-none w-full bg-white border px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline">
								<template v-for="region in regions">
									<option :value="region.id" :key="region.id">{{ region.name }}</option>
								</template>
							</select>
							<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
					</div>
					<div v-if="loading">
						Loading
					</div>
					<template v-else v-for="profile in profiles">
						<template v-for="profileLoop in profilesToLoop">
							<template v-if="profile.id == profileLoop.id && profile.users.length">
								<div class="mb-4 p-1">
									<label class="block text-gray-700 text-sm mb-2">
										{{ profileLoop.name }}
									</label>
									<div class="w-full inline-block relative">
										<select :multiple="profileLoop.multiple" v-model="job.details[profileLoop.model]" :name="job.details[profileLoop.model]" class="block appearance-none w-full bg-white border px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline">
											<template v-for="user in profile.users">
												<option :value="user.id" :key="user.id">{{ user.name }}</option>
											</template>
										</select>
										<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" v-if="profileLoop.model">
											<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
										</div>
									</div>
								</div>
							</template>
							<template v-if="profile.id == profileLoop.id && !profile.users.length">
								<div class="mb-4 p-1">
									No {{ profileLoop.name }}'s registered in system for this region
								</div>
							</template>
						</template>
					</template>
					<div class="mb-4 p-1">
						<label class="block text-gray-700 text-sm mb-2" for="site_storeman">
							Job Start Date
						</label>
						<div class="w-full inline-block relative">
							<div v-if="loading">
								Loading
							</div>
							<div v-else>
								<datetime type="date" value-zone="local" class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="start_datetime" v-model="job.details.start_datetime"></datetime>
							</div>
						</div>
					</div>
				</div>
				<div class="w-1/2">
					<div class="mb-4 p-1">
						<label class="block text-gray-700 text-sm mb-2" for="username">
							Client
						</label>
						<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="client" v-model="job.details.client" type="text" placeholder="Client">
					</div>
					<div class="mb-4 p-1">
						<label class="block text-gray-700 text-sm mb-2" for="address1">
							Street Address
						</label>
						<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="addr1" v-model="job.details.address1" type="text" placeholder="Street Address">
					</div>
					<div class="flex">
						<div class="mb-4 p-1">
							<label class="block text-gray-700 text-sm mb-2" for="address2">
								Address 2
							</label>
							<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="addr2" v-model="job.details.address2" type="text" placeholder="Address 2">
						</div>
						<div class="mb-4 p-1">
							<label class="block text-gray-700 text-sm mb-2" for="unit_no">
								Complex / Unit number
							</label>
							<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="unit" v-model="job.details.unit_no" type="text" placeholder="Complex / Unix Number">
						</div>
					</div>
					<div class="flex">
						<div class="mb-4 p-1">
							<label class="block text-gray-700 text-sm mb-2" for="city">
								City
							</label>
							<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="city" v-model="job.details.city" type="text" placeholder="City">
						</div>
						<div class="mb-4 p-1">
							<label class="block text-gray-700 text-sm mb-2" for="province">
								Province
							</label>
							<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="province" v-model="job.details.province" type="text" placeholder="Province">
						</div>
					</div>
					<div class="flex">
						<div class="mb-4 p-1">
							<label class="block text-gray-700 text-sm mb-2" for="postalcode">
								Postal Code
							</label>
							<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="postalcode" v-model="job.details.postalcode" type="text" placeholder="Postal Code">
						</div>
					</div>
				</div>
			</div>
			</fetch-json>
		</form>
		<div class="mt-4 p-2" v-if="!this.$route.params.id">
			<div class="flex justify-end items-center">
				<div class="flex items-center mr-4">
					<label class="inline-block mr-4 text-gray-700 text-sm" for="starting_phase">Starting Phase Number</label>
					<input class="appearance-none border rounded w-16 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" id="starting_phase" v-model="job.details.phase" type="text" placeholder="Postal Code">
				</div>
				<action-button class="btn btn-blue" @button-clicked="saveJob()">Save Job</action-button>
			</div>
		</div>
		<div class="flex py-2 my-2 justify-end" v-if="this.$route.params.id">
			<div class="flex ml-1 items-center" v-if="job.details.status=='pending'">
				<action-button class="btn btn-green" @button-clicked="changeJobStatus('publish')">Publish</action-button>
			</div>
			<div class="flex ml-1 items-center" v-if="job.details.status=='active'">
				<action-button class="btn btn-red" @button-clicked="changeJobStatus('unpublish')">Unpublish</action-button>
			</div>
			<div class="flex ml-1 items-center">
				<action-button class="btn btn-blue" @button-clicked="updateJob()">Update</action-button>
			</div>
		</div>
	</div>
</template>

<script>
import { Datetime } from 'vue-datetime';

export default {

	name: 'AddJob',

	data () {
		return {
			job: {
				details: {
					id: this.$route.params.id || null,
					name: '',
					client: '',
					site_manager: null,
					site_storeman: null,
					foreman: [],
					address1: '',
					address2: '',
					unit_no: '',
					city: '',
					province: '',
					postalcode: '',
					start_datetime: new Date().toISOString(),
					region: null,
					phase: 1
				},
				phases: []
			},
			regions:{},
			self: this,
			profilesToLoop: [
				{
					id: 3,
					name: 'Site Manager',
					model: 'site_manager'
				},
				{
					id: 6,
					name: 'Site Storeman',
					model: 'site_storeman'
				},
				{
					id: 5,
					name: 'Foreman',
					model: 'foreman',
					multiple: true
				},
			],
		}
	},
	computed: {
		userRegionId: function() {
			return this.$store.getters['auth/region_id'];
		}
	},
	methods: {
		reload: function () {
			if (this.$route.params.id) {
				var jobId = this.$route.params.id
				this.$http.get(`jobs/${jobId}`)
					.then(response => {
						this.job.details = response.data.jobdetails;
						this.job.details.foreman = response.data.foreman;
						this.job.details.start_datetime = new Date(response.data.jobdetails.start_datetime).toISOString();
						this.$store.commit('setJobName', this.job.details.name)
					})
					.catch(err => {
						this.error = err
					})
			}
		},
		changeJobStatus: function (status) {
			this.$http.post(`jobs/${this.$route.params.id}/status`, {'status':status})
				.then((response) => {
					this.$router.push({ path: `/` })
				}).catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors
					}
				})
			// .finally(() => {
			// 	this.$store.commit('setLoading', false);
			// });
		},
		saveJob: function () {
			this.$http.post('jobs', this.job.details)
				.then((response) => {
					this.$router.push({ path: `/job/${response.data.job_id}` })
				}).catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors
					}
				})
			// .finally(() => {
			// 	this.$store.commit('setLoading', false);
			// });
		},
		updateJob: function () {
			this.$http.patch(`jobs/${this.$route.params.id}`, this.job.details)
				.then((response) => {
					this.$router.push({ path: `/job/${this.$route.params.id}` })
				}).catch((error) => {
					console.log(error)
					if (error.response.status === 422) {
						this.errors = error.response.data.errors
					}
				})
			// .finally(() => {
			// 	this.$store.commit('setLoading', false);
			// });
		}
	},
	components: {
		datetime: Datetime,
	},
	created: function () {
		this.$http.get(`regions`)
			.then(response => {
				this.regions = response.data
			})
			.catch(err => {
				this.error = err
			})
		if (this.$route.params.id) {
			this.reload()
		}
		this.job.details.region = this.$store.getters['auth/region_id'];
	}
}
</script>

<style lang="css" scoped>
</style>
